import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-admin-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-page-header.component.html',
  styleUrl: './admin-page-header.component.scss',
})
export class AdminPageHeaderComponent {
  @Input({ required: true }) title = '';
  @Input() subtitle = '';
}
